import React, { useState } from 'react';

import Section from '../../containers/Section';
import logo from '../../assets/logo.svg';
import { SiInstagram, SiDribbble, SiTwitter, SiYoutube } from 'react-icons/si'
import { FiSend } from 'react-icons/fi';

const Footer = () => {
  const [emailStayUpdate, setEmailStayUpdate] = useState('');

  const onChange = event => { setEmailStayUpdate(event.target.value); }

  return (
    <Section innerClass="pb-10 pt-14 text-white max-w-[90%] md:flex md:flex-wrap md:items-center lg:items-start xl:max-w-[80%] 2xl:max-w-[70%]" outerClass="bg-slate-900">
      <div className="md:basis-1/2 lg:basis-1/3 lg:mt-1.5">
        <div className="md:h-8">
          <img src={logo} alt="" className="h-8" />
        </div>
        <p className="text-xs text-white tracking-wide mt-4">Copyright &copy; 2022 Cotechca Project - All rights reserved.</p>
        <div className="flex space-x-4 my-14">
          <button className="p-3 rounded-full bg-slate-700">
            <SiInstagram />
          </button>
          <button className="p-3 rounded-full bg-slate-700">
            <SiDribbble />
          </button>
          <button className="p-3 rounded-full bg-slate-700">
            <SiTwitter />
          </button>
          <button className="p-3 rounded-full bg-slate-700">
            <SiYoutube />
          </button>
        </div>
      </div>
      <div className="md:basis-1/2 lg:basis-1/3">
        <div className="flex mt-8 md:mt-0 md:mb-8">
          <div className="basis-1/2 md:basis-auto md:ml-8">
            <div className="space-y-4 md:pr-10">
              <div>
                <div className="text-xl tracking-wider font-medium">Company</div>
              </div>
              <div className="space-y-2">
                <button className="block font-light">About us</button>
                <button className="block font-light">Blog</button>
                <button className="block font-light">Contact us</button>
                <button className="block font-light">Pricing</button>
                <button className="block font-light">Testimonials</button>
              </div>
            </div>
          </div>
          <div className="basis-1/2 md:basis-auto">
            <div className="space-y-4">
              <div>
                <div className="text-xl tracking-wider font-medium">Support</div>
              </div>
              <div className="space-y-2 font-light">
                <button className="block font-light">Help center</button>
                <button className="block font-light">Terms of service</button>
                <button className="block font-light">Legal</button>
                <button className="block font-light">Privacy</button>
                <button className="block font-light">Status</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="md:basis-1/2 lg:basis-1/3">
        <div className="mt-8 md:mt-0">
          <div className="text-xl tracking-wider font-medium">Stay up to date</div>
          <label htmlFor="email-stay-update" className="block w-2/3 relative mt-2">
            <input
              id="email-stay-update"
              name="emailStayUpdate"
              className="w-full rounded-md px-4 py-3 text-white placeholder:text-white/70 focus:outline-none focus:ring focus:ring-main text-base font-light bg-slate-500"
              placeholder="Your email address..."
              value={emailStayUpdate}
              onChange={onChange}
            />
            <button className="absolute h-full top-0 right-0 flex items-center px-4 z-10">
              <FiSend size={24} />
            </button>
          </label>
        </div>
      </div>
    </Section>
  );
};

export default Footer;
